
    import './styles.scoped.css';
    export default {
  "segment__path": "awsui_segment__path_1edmh_b6wa3_97",
  "segment": "awsui_segment_1edmh_b6wa3_97",
  "segment__hover": "awsui_segment__hover_1edmh_b6wa3_124",
  "label": "awsui_label_1edmh_b6wa3_138",
  "root": "awsui_root_1edmh_b6wa3_156",
  "content": "awsui_content_1edmh_b6wa3_160",
  "content--small": "awsui_content--small_1edmh_b6wa3_160",
  "content--fit-height": "awsui_content--fit-height_1edmh_b6wa3_163",
  "content--without-labels": "awsui_content--without-labels_1edmh_b6wa3_166",
  "content--medium": "awsui_content--medium_1edmh_b6wa3_172",
  "content--large": "awsui_content--large_1edmh_b6wa3_184",
  "status-container": "awsui_status-container_1edmh_b6wa3_201",
  "chart-container": "awsui_chart-container_1edmh_b6wa3_205",
  "chart-container--fit-height": "awsui_chart-container--fit-height_1edmh_b6wa3_209",
  "chart-container-chart-plot": "awsui_chart-container-chart-plot_1edmh_b6wa3_214",
  "chart-container-chart-plot--fit-height": "awsui_chart-container-chart-plot--fit-height_1edmh_b6wa3_217",
  "inner-content": "awsui_inner-content_1edmh_b6wa3_223",
  "segment__highlight": "awsui_segment__highlight_1edmh_b6wa3_234",
  "segment--dimmed": "awsui_segment--dimmed_1edmh_b6wa3_249",
  "segment--highlighted": "awsui_segment--highlighted_1edmh_b6wa3_252",
  "label--dimmed": "awsui_label--dimmed_1edmh_b6wa3_269",
  "label--align-right": "awsui_label--align-right_1edmh_b6wa3_272",
  "label-text": "awsui_label-text_1edmh_b6wa3_280",
  "label__description": "awsui_label__description_1edmh_b6wa3_288",
  "label-line": "awsui_label-line_1edmh_b6wa3_295",
  "label--highlighted": "awsui_label--highlighted_1edmh_b6wa3_299",
  "popover-header": "awsui_popover-header_1edmh_b6wa3_303"
};
  